module.exports = __webpack_public_path__ + "img/Warrior-human-m-70.6fd4af76.gif";